import * as XLSX from "xlsx";

export const exportToExcel = (data: any[], fileName: string) => {
  const processedData = data.map((item) => {
    const flattenedItem = { ...item };
    Object.keys(flattenedItem).forEach((key) => {
      if (Array.isArray(flattenedItem[key])) {
        flattenedItem[key] = flattenedItem[key].join(", ");
      }
    });
    return flattenedItem;
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(processedData);
  XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
